<div class="uom-container" *ngIf="productItem">
  <!-- Weight -->
  <div class="uom-section">
    <div class="uom-value">{{ uomCategory }}</div>
    <div class="uom-label">Units of Measure</div>
  </div>

  <!-- Liters -->
  <div class="uom-section">
    <div class="uom-value">{{ measurement }}</div>
    <div class="uom-label">Measurement</div>
  </div>

  <!-- 1 -->
  <div class="uom-section">
    <div class="uom-value">{{ units }}</div>
    <div class="uom-label">How many units</div>
  </div>
</div>
